import { render, staticRenderFns } from "./TitlesUpdate.vue?vue&type=template&id=1c413644"
import script from "./TitlesUpdate.vue?vue&type=script&lang=js"
export * from "./TitlesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports